import React from "react";
import useReviews from "../../../hooks/useReviews";
import Review from '../Review/Review'
import "./Feedback.css";

const Feedback = () => {
  const [reviews, setReviews] = useReviews();

  return (
    <div className="feedback">
      <h1>What my customers say about me!</h1>
      {reviews.map(user_review => <Review key={user_review._id} user_review={user_review}></Review>)}
    </div>
  );
};

export default Feedback;
